import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * @TODO - Needs description.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Table({ rows = [] }) {
  /**
   * renderCellAmount
   *
   * @TODO Needs description.
   *
   * @param cell
   * @returns {JSX.Element}
   */
  const renderCellAmount = ({ cell }) => {
    return <React.Fragment>{Number(cell?.value).toLocaleString('en-US')}</React.Fragment>;
  };

  /**
   * renderCellSource
   *
   * @TODO Needs description.
   *
   * @param cell
   * @returns {JSX.Element}
   */
  const renderCellSource = ({ cell }) => {
    return <React.Fragment>{cell.value}</React.Fragment>;
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header === 'Source') {
        column.Cell = renderCellSource;
      }

      if (column.Header === 'Amount') {
        column.Cell = renderCellAmount;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/UntrustedSources/components/Table/Table.jsx">
      <TableComponent
        {...{
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
